import React, { Component } from 'react';
import { connect } from 'react-redux';
import { api } from '../services/rest';
import { fetchMenuItems } from '../actions/menuActions';
import { withRouter, Link, NavLink } from 'react-router-dom';
//import SideBarMenu from '../components/Menu/SideBar';
import MenuItem from '../components/Menu/MenuItem';
import SubMenu from '../components/Menu/SubMenu';
import { session } from '../authentication';

class ProjectMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            adminIds: []
        }
    }
    componentDidMount() {
        this.props.fetchMenuItems(this.props.client, this.props.project);
        api.get("/Projects/AdminIds")
            .then(res => this.setState({ adminIds: res.data }));
    }

    componentDidUpdate(prevProps) {
        if (this.props.client !== prevProps.client
            || this.props.project !== prevProps.project) {
            this.props.fetchMenuItems(this.props.client, this.props.project);
        }
    }

    render() {
        //console.log(this.props);
        var currentUser = session.getUser();
        const items = this.props.items;
        const settingsLink = (this.state.adminIds.find(x => x === currentUser.id)) ?
            <li>
                <NavLink to={`/${this.props.client}/${this.props.project}/ProjectSettings/`} activeClassName="active"><span className="glyphicon glyphicon-cog mr-sm" />
                    <strong>Settings</strong>
                </NavLink>
            </li> : "";
        const not = condition => condition ? false : true;
        const text = (item) => item.subItems && not(item.added) ? <> {item.text} <Link to={`${item.url}/New`} className="btn btn-info pull-right" title="Create a new item in this category">Add</Link> </> : item.text;
        const subMenuStyle = {
            paddingTop: '0px',
            marginLeft: '15px',
            marginBottom: '30px'

        };
        items.forEach(item => { item.text = text(item); item.added = true });
        return (
            <nav className={this.props.className}>
                <ul className="nav sidebar-nav text-capitalize">
                    <li>
                        <NavLink exact={true} to={`/${this.props.client}/${this.props.project}`} activeClassName="active"><span className="glyphicon glyphicon-home mr-sm" /> <strong>{this.props.client} {this.props.project}</strong></NavLink>
                    </li>
                    {/*<li>
                        <NavLink exact={true} to={`/${this.props.client}/${this.props.project}`} activeClassName="active"><span className="glyphicon glyphicon-plus mr-sm" /> <strong>{this.props.client} {this.props.project}</strong></NavLink>
                    </li>*/}
                    {items.map(item => <MenuItem item={item} key={item.text} />)}
                    <li>
                        <NavLink to={`/${this.props.client}/${this.props.project}/Resources/`} activeClassName="active"><span className="glyphicon glyphicon-picture mr-sm" /> 
                            <strong>Resources</strong>
                        </NavLink>
                    </li>
                    {settingsLink}
                    <SubMenu className="nav sidebar-nav text-capitalize" text="Build" hasSubMenu={true} subMenuIsOpen={false} url="" glyphIcon="ok">
                        <MenuItem url={`/#/${this.props.client}/${this.props.project}/Preview`} text="Preview"/>
                        <MenuItem url={`/#/${this.props.client}/${this.props.project}/Publish`} text="Publish Live Site"/>
                    </SubMenu>
                    <SubMenu className="nav sidebar-nav text-capitalize" text="Go To..." hasSubMenu={true} subMenuIsOpen={false} url="" glyphIcon="home">
                        <MenuItem url={this.props.previewUrl} text="Preview Site" target="_blank" />
                        <MenuItem url={this.props.liveUrl} text="Live Site" target="_blank" />
                    </SubMenu>      
                </ul>
            </nav>
        )
    }
}
//<div className="dropright nav sidebar-nav text-capitalize">
//    <li>
//        <a className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
//            <span className="glyphicon glyphicon-ok mr-sm" />
//            <strong>Build</strong>
//        </a>
//    </li>
//    <div className="dropdown-menu">
//        <ul className="text-capitalize">
//            <li>
//                <NavLink to={`/${this.props.client}/${this.props.project}/Preview`} activeClassName="active">
//                    <strong>Preview</strong></NavLink>
//            </li>
//            <li>
//                <NavLink to={`/${this.props.client}/${this.props.project}/Publish`} activeClassName="active">
//                    <strong>Publish to Live</strong></NavLink>
//            </li>
//        </ul>
//    </div>
//</div>
//<div className="dropright nav sidebar-nav text-capitalize">
                        //    <li>
                        //        <a className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        //            <span className="glyphicon glyphicon-globe mr-sm" />
                        //            <strong>Go To...</strong>
                        //        </a>
                        //    </li>
                        //    <div className="dropdown-menu">
                        //        <ul className="text-capitalize">
                        //            <li>
                        //                <a href={this.props.previewUrl}><strong>Preview site</strong></a>
                        //            </li>
                        //            <li>
                        //                <a href={this.props.liveUrl}><strong>Live site</strong></a>
                        //            </li>
                        //        </ul>
                        //    </div>
                        //</div>

const mapStateToProps = (state) => {
    //console.log(state);
    return {
        items: state.menu.items,
        liveUrl: state.menu.liveUrl,
        previewUrl: state.menu.previewUrl
    }
};

export default withRouter(connect(mapStateToProps, { fetchMenuItems })(ProjectMenu));